import { DataGrid } from "@material-ui/data-grid";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import userProfileDefaultPic from "../assets/images/user-profile.png";
import AntSwitch from "../main/component/AntSwitch";
import SongInfoDrawer from "./component/SongInfoDrawer";
import { changeEditorsPick, getEditorsPick } from "./services/songApi";

import "react-datepicker/dist/react-datepicker.css";
import "../main/main.css";
import "./EditorsPickPage.css";

const EditorsPickPage = () => {
  const [rows, setRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
  // const [loading, setLoading] = useState(false);

  const [filteredRows, setFilteredRows] = useState(rows);
  const [searchByName, setSearchByName] = useState("");
  const [searchByVideoTitle, setSearchByVideoTitle] = useState("");

  const loadSongs = async () => {
    // setLoading(true);
    const { data } = await getEditorsPick();
    setRows(data);
    setFilteredRows(data);
    // setLoading(false);
  };

  useEffect(() => {
    loadSongs();
  }, []);

  const addToOrRemoveFromEditorPick = async (songId, pick) => {
    console.log("switch change event called");
    try {
      const response = await changeEditorsPick(songId, pick);
      await loadSongs();
    } catch (e) {
      console.log("error occurred");
    }
  };

  const columns = [
    {
      field: "",
      headerName: "Id",
      width: 200,
      renderCell: (params) => {
        return (
          <span
            onClick={() => {
              setSelectedRow(params.row);
              setOpen(true);
            }}
          >
            {params.row._id}{" "}
          </span>
        );
      },
    },
    {
      field: "title",
      headerName: "Video Title",
      width: 150,
      renderCell: (params) => {
        return <strong style={{ color: "#000" }}>{params.row.title}</strong>;
      },
    },
    {
      field: "genre",
      headerName: "Genre",
      width: 100,
    },
    {
      field: "createdAt",
      headerName: "Date & Time",
      width: 150,
      renderCell: (params) => {
        return (
          <span>
            {moment(params.row.createdAt).format("DD-MMM-YYYY hh:mm A")}
          </span>
        );
      },
    },
    {
      field: "user.firstname",
      headerName: "Artist",
      width: 150,
      renderCell: (params) => {
        return (
          <React.Fragment>
            <img
              src={
                (params.row.user && params.row.user.profilePhotoUrl) ||
                userProfileDefaultPic
              }
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = userProfileDefaultPic;
              }}
              alt="profile-pic"
              width={15}
              height={15}
              style={{ borderRadius: "100%" }}
            />
            <span style={{ marginLeft: "5px", textTransform: "capitalize" }}>
              {params.row.user
                ? `${params.row.user.firstname} ${params.row.user.lastname}`
                : ""}
            </span>
          </React.Fragment>
        );
      },
    },
    {
      field: "user.location.city",
      headerName: "Location",
      width: 200,
      renderCell: (params) => {
        return (
          <span>
            {params.row.user &&
              params.row.user.location &&
              `${params.row.user.location.city} ${params.row.user.location.state} ${params.row.user.location.country} `}
          </span>
        );
      },
    },
    {
      field: "editorPick",
      headerName: "Editor Pick",
      width: 100,
      renderCell: (params) => {
        return (
          <AntSwitch
            checked={params.row.editorPick}
            onChange={() => {
              addToOrRemoveFromEditorPick(
                params.row._id,
                !params.row.editorPick
              );
            }}
          />
        );
      },
    },
  ];

  const search = () => {
    const theFilteredRows = rows.filter(
      (theRow) =>
        (searchByName
          ? theRow.user.firstname &&
            theRow.user.firstname.toUpperCase().startsWith(searchByName.toUpperCase())
          : true) &&
        (searchByVideoTitle
          ? theRow.title && theRow.title.toUpperCase().startsWith(searchByVideoTitle.toUpperCase())
          : true)
    );

    setFilteredRows(theFilteredRows);
  };

  const reset = () => {
    setSearchByName("");
    setSearchByVideoTitle("");
    setFilteredRows(rows);
  };

  return (
    <div
      style={{
        minHeight: 620,
        width: "100%",
      }}
    >
      <div
        style={{
          height: 530,
          width: "100%",
          display: "inline-block",
          paddingTop: 100,
        }}
        className="song-container"
      >
        <div className="search-by-name-container">
          <label className="mc-label">Name</label>
          <div>
            <input
              type="text"
              value={searchByName}
              onChange={(e) => setSearchByName(e.target.value)}
            />
          </div>
        </div>
        <div className="search-by-location-container">
          <label className="mc-label">Video title</label>
          <div>
            <input
              type="text"
              value={searchByVideoTitle}
              onChange={(e) => setSearchByVideoTitle(e.target.value)}
            />
          </div>
        </div>
        <div className="search-by-date-btn" onClick={search}>
          Search
        </div>
        <div className="reset-btn" onClick={reset}>
          Reset
        </div>
        {filteredRows && filteredRows.length > 0 && (
          <DataGrid
            getRowId={(row) => row._id}
            rows={filteredRows}
            columns={columns}
            rowsPerPageOptions={[5, 10, 20, 50]}
            pageSize={10}
            disableSelectionOnClick
          />
        )}
        <SongInfoDrawer
          selectedRow={selectedRow}
          open={open}
          setOpen={setOpen}
        />
      </div>
    </div>
  );
};

export default EditorsPickPage;
